import { initReactI18next } from "react-i18next";

import i18next, { i18n } from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import ChainedBackend, { ChainedBackendOptions } from "i18next-chained-backend";

import { apiConfig, environementConfig } from "../../environmentConfiguration";
import { FallbackLocalTranslationsLoader } from "./FallbackLocalTranslationLoader";
import { HttpBackendTranslationLoader } from "./HttpBackendTranslationLoader";

export const initLocalization = async (
  token: string,
  backendUnavailableCallback: () => void,
  insufficientPermissionsFallback: () => void,
): Promise<i18n> => {
  await i18next
    .use(LanguageDetector)
    .use(initReactI18next)
    .use(ChainedBackend)
    .init<ChainedBackendOptions>({
      fallbackLng: "en",
      supportedLngs: ["de", "en", "fr"],
      detection: {
        order: ["localStorage", "navigator"],
        caches: ["localStorage"],
        lookupLocalStorage: "i18nextLng",
      },
      debug: false,
      interpolation: {
        escapeValue: false,
      },
      maxRetries: 2,
      backend: {
        backends: [
          HttpBackendTranslationLoader, // Translations from backend,
          FallbackLocalTranslationsLoader, // Fallback local translations for error pages
        ],
        backendOptions: [
          {
            loadPath: `${apiConfig.baseUrl}/api/Whitelabel/translations.{{lng}}.json`,
            customHeaders: {
              authorization: `Bearer ${token}`,
            },
            insufficientPermissionsFallback,
          },
          {
            loadPath:
              (environementConfig.isPipelineBuild ? `/assets/` : `/src/assets/locales/`) +
              `translations.{{lng}}.json?url`, // Local fallback translations in public folder
            backendUnavailableCallback,
          },
        ],
      },
    });

  return i18next;
};
